import { render, staticRenderFns } from "./pivotOptions.vue?vue&type=template&id=2e6843c0&scoped=true&"
import script from "./pivotOptions.vue?vue&type=script&lang=js&"
export * from "./pivotOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6843c0",
  null
  
)

export default component.exports